import Joi from 'joi'

export interface LegalDocumentFormValues {
  name: string
  versionMajor: number
  versionMinor: number
  versionPatch: number
  documentType: string
  content: string
  originalFileUri?: string
  originalFileName?: string
}

export const LegalDocumentValidation = Joi.object<LegalDocumentFormValues>({
  name: Joi.string().required().max(200).messages({
    'string.empty': 'Document name is required',
    'string.max': 'Document name must not exceed 200 characters',
  }),
  versionMajor: Joi.number().integer().min(0).required().messages({
    'number.base': 'Version major must be a number',
    'number.integer': 'Version major must be an integer',
    'number.min': 'Version major must be non-negative',
  }),
  versionMinor: Joi.number().integer().min(0).required().messages({
    'number.base': 'Version minor must be a number',
    'number.integer': 'Version minor must be an integer',
    'number.min': 'Version minor must be non-negative',
  }),
  versionPatch: Joi.number().integer().min(0).required().messages({
    'number.base': 'Version patch must be a number',
    'number.integer': 'Version patch must be an integer',
    'number.min': 'Version patch must be non-negative',
  }),
  documentType: Joi.string().required().messages({
    'string.empty': 'Document type is required',
  }),
  content: Joi.string().required().messages({
    'string.empty': 'Document content is required',
  }),
  originalFileUri: Joi.string().allow('', null).optional(),
  originalFileName: Joi.string().allow('', null).optional(),
})
